// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA37Bpz3Dmg7HjS3f9CPdp5x7XpRxl1aZE",
  authDomain: "peshkar.firebaseapp.com",
  projectId: "peshkar",
  storageBucket: "peshkar.appspot.com",
  messagingSenderId: "968930087612",
  appId: "1:968930087612:web:878529a271f3c5d3fb36b9",
  measurementId: "G-JD72J0BW9S"
};

// Initialize Firebase
//const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
// Initialize Firebase
// Use this to initialize the firebase App
firebase.initializeApp(firebaseConfig);

// Use these for db & auth
//const analytics = getAnalytics(db);
export default firebase;